import {useEffect, useLayoutEffect} from 'react';

/**
 * Problem
 * Warning: useLayoutEffect does nothing on the server,
 * because its effect cannot be encoded into the server renderer's output format.
 * This will lead to a mismatch between the initial, non-hydrated UI and the intended UI.
 *
 * @see-https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85?permalink_comment_id=4692473#gistcomment-4692473
 */
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
